import React, { MouseEvent } from 'react';
import { Input, Label, Mark, RadioWrapper } from './Radio.styled';
import { ComponentProps } from './Radio.types';

const Radio: React.FC<ComponentProps> = React.forwardRef(
  ({ disabled, clickHandler, value, name, children, isChecked, ...props }, forwardedRef) => {
    const handleClick = (e: MouseEvent<HTMLInputElement>) => {
      const element = e.target as HTMLInputElement;
      const inputValue = element.value;
      if (typeof clickHandler === 'function') clickHandler(inputValue);
    };

    return (
      <div>
        <RadioWrapper>
          <Label tabIndex={0}>
            <Input
              ref={forwardedRef}
              name={name}
              value={value}
              checked={isChecked}
              onClick={!disabled ? handleClick : undefined}
              disabled={disabled}
              type="radio"
              {...props}
            />
            <Mark newUi={props.newUi} />
            {children}
          </Label>
        </RadioWrapper>
      </div>
    );
  },
);

export default Radio;
